import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const LineReveal = ({
  children,
  delay = 0,
  duration = 1,
  className = "",
  as: Tag = "span",
  "data-testid": testId,
}) => {
  return (
    <span className="reveal-mask" data-testid={testId}>
      <motion.span
        style={{ display: "inline-block", willChange: "transform" }}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration, delay, ease: EASE }}
        className={className}
      >
        <Tag>{children}</Tag>
      </motion.span>
    </span>
  );
};

export const WordsReveal = ({ text, className = "" }) => {
  return <span className={className}>{text}</span>;
};

export const FadeUp = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);
